export default class StringKind {
	static SHORT = 'SHORT';
	static LONG = 'LONG';
	static HTML = 'HTML';
}
